import {
  FETCH_VIDEOS_REQUEST,
  FETCH_VIDEOS_SUCCESS,
  FETCH_VIDEOS_ERROR,
  UPDATE_VIDEOS_REQUEST,
  UPDATE_VIDEOS_SUCCESS,
  UPDATE_VIDEOS_ERROR,
  REMOVE_VIDEOS_SUCCESS,
  REMOVE_VIDEOS_ERROR,
  FETCH_LATEST_VIDEO_REQUEST,
  FETCH_LATEST_VIDEO_SUCCESS,
  FETCH_LATEST_VIDEO_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
  latest: {
    record: {},
    error: null,
    isFetching: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_VIDEOS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_VIDEOS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: action.payload,
        },
        edit: {
          error: null,
        },
      }

    case FETCH_VIDEOS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: action.payload,
        },
        edit: {
          error: null,
        },
      }

    case UPDATE_VIDEOS_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_VIDEOS_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: action.payload,
          updated: true,
          removed: false,
        },
      }

    case UPDATE_VIDEOS_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: action.payload.error,
          record: action.payload.toSave,
          updated: false,
          removed: false,
        },
      }

    case REMOVE_VIDEOS_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: null,
          updated: false,
          removed: true,
        },
      }

    case REMOVE_VIDEOS_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          removed: false,
        },
      }

    case FETCH_LATEST_VIDEO_REQUEST:
      return {
        ...state,
        latest: {
          ...state.latest,
          isFetching: true,
        },
      }

    case FETCH_LATEST_VIDEO_SUCCESS:
      return {
        ...state,
        latest: {
          ...state.latest,
          isFetching: false,
          error: null,
          record: action.payload,
        },
      }

    case FETCH_LATEST_VIDEO_ERROR:
      return {
        ...state,
        latest: {
          ...state.latest,
          isFetching: false,
          record: [],
          error: action.payload,
        },
      }

    default:
      return state
  }
}

export default record
